export const isThemeEqual = (themeA, themeB) => {
    return JSON.stringify(themeA) === JSON.stringify(themeB);
  };
  